
interface Props {
	msg: string
}
export const showErrorMessage = ({ msg }: Props) => {
	const appElem = document.getElementById("app")
	if (appElem) {
		appElem.innerHTML = `<div class='error-msg'>${msg}</div>`
	}
}